<template>
  <div>
    <div class="voortgang" style="float:right;">
      <div class="voortgangtitlesholder">
        <span class="voortgangtitel">In behandeling</span>
        <span class="voortgangtitel">Uitgezet</span>
        <span class="voortgangtitel">Geaccepteerd</span>
        <span class="voortgangtitel">Gestart</span>
        <span class="voortgangtitel">Beindigd</span>
      </div>
      <div class="voortgangholder">
        <!-- cirkel 1 -->
        <div v-if="opdracht.status == 'Nieuw'" class="circle">
          <div class="line"></div>
        </div>
        <div v-if="opdracht.status != 'Nieuw'" class="circle-check">
          <div class="line-check"></div>
        </div>

        <!-- Toegewezen cirkel -->
        <div v-if="opdracht.status == 'Toegewezen'" class="circle" style="background-color:#ff9326;">
          <div class="line" style="background-color:#ff9326;"></div>
        </div>

        <!-- cirkel 2 -->
        <div v-if="(opdracht.status != 'Uitgezet' && opdracht.status == 'In behandeling') || opdracht.status == 'Nieuw'" class="circle">
          <div class="line"></div>
        </div>
        <div v-if="opdracht.status != 'Toegewezen' && opdracht.status != 'Nieuw' && opdracht.status != 'In behandeling'" class="circle-check">
          <div class="line-check"></div>
        </div>

        <!-- cirkel 3 -->
        <div v-if="opdracht.status != 'Geaccepteerd' && opdracht.status != 'Gestart' && opdracht.status != 'Geaccepteerd' && opdracht.status != 'Beëindigd'" class="circle">
          <div class="line"></div>
        </div>
        <div v-if="opdracht.status == 'Gestart' || opdracht.status == 'Geaccepteerd' || opdracht.status == 'Beëindigd'" class="circle-check">
          <div class="line-check"></div>
        </div>

        <!-- cirkel 4 -->
        <div v-if="opdracht.status != 'Gestart' && opdracht.status != 'Beëindigd'" class="circle-heart">
          <div class="line"></div>
        </div>
        <div v-if="opdracht.status != 'Nieuw' && opdracht.status != 'In behandeling' && opdracht.status != 'Uitgezet' && opdracht.status != 'Toegewezen' && opdracht.status != 'Geaccepteerd'" class="circle-heart-check" style="width: 24px !important">
          <div class="line-check"></div>
        </div>

        <!-- cirkel 5 -->
        <div v-if="opdracht.status != 'Beëindigd'" class="square"></div>
        <div v-if="opdracht.status == 'Beëindigd'" class="square-check"></div>

        <!-- annuleer-kruis NIET -->
        <div v-if="opdracht.geannuleerd != true" class="geannuleerdnot"></div>

        <!-- annuleer-kruis -->
        <div v-if="opdracht.geannuleerd == true || opdracht.status == 'Geannuleerd'" class="geannuleerd"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Voortgang",
  props: {
    opdracht: Object
  }
}
</script>

<style>
.voortgangtitlesholder {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 4px;
}

.voortgangholder {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -ms-flex-item-align: center;
}

.circle {
  position: relative;
  width: 23px;
  height: 23px;
  margin-right: 14px;
  border-radius: 100px;
  background-color: #b8c3d5;
}

.circle-heart {
  position: relative;
  width: 24px !important;
  height: 23px;
  margin-right: 14px;
  background-image: url("../../assets/voortgang/heart-gray.png");
  background-position: center;
  background-size: 30px;
}
.circle-heart-check {
  position: relative;
  width: 24px !important;
  height: 23px;
  margin-right: 14px;
  background-image: url("../../assets/voortgang/heart-red.png");
  background-position: center;
  background-size: 30px;
}

.geannuleerd {
  position: relative;
  width: 30px;
  height: 30px;
  margin-right: 14px;
  background-image: url("../../assets/voortgang/geannuleerd-ico.png");
  background-position: center;
  background-size: 30px;
}

.geannuleerdnot {
  position: relative;
  width: 30px;
  height: 30px;
  margin-right: 14px;
  background-image: url("../../assets/voortgang/geannuleerd-ico.png");
  background-position: center;
  background-size: 30px;
  filter: grayscale();
  opacity: 0.5;
  cursor: pointer;
}

.circle-check {
  position: relative;
  width: 23px;
  height: 23px;
  margin-right: 14px;
  border-radius: 100px;
  background-color: #3076ea;
}

.square {
  position: relative;
  width: 19px;
  height: 19px;
  margin-right: 14px;
  /* border-radius: 100px; */
  background-color: #b8c3d5;
  transform: rotate(45deg);
}
.square-check {
  position: relative;
  width: 19px;
  height: 19px;
  margin-right: 14px;
  /* border-radius: 100px; */
  transform: rotate(45deg);
  background-color: #35dd83;
  border-radius: 0px !important;
}

.line {
  position: absolute;
  left: auto;
  top: 50%;
  right: -18px;
  bottom: auto;
  width: 20px;
  height: 4px;
  background-color: #b8c3d5;
  transform: translate(0px, -50%);
}
.line-check {
  position: absolute;
  left: auto;
  top: 50%;
  right: -18px;
  bottom: auto;
  width: 20px;
  height: 4px;
  background-color: #3076ea;
  transform: translate(0px, -50%);
}
</style>
